
<div class="lm-drill-point-list-container form-layout-compact full-height full-width">
  <soho-toolbar-flex-section *ngIf="false"  class="toolbar-section favor title">
    <h2>
      <!--<span *ngIf="selectedNode && selectedNode.lmChildren && selectedNode.lmChildren.length > 0">{{selectedNode.text ? selectedNode.text : selectedNode.badge.text}}</span>-->
      <span *ngIf="selectedNode && selectedNode.lmChildren && selectedNode.lmChildren.length > 0">{{selectedNode.text}}</span>
      <span *ngIf="!selectedNode || !selectedNode.lmChildren || selectedNode.lmChildren.length === 0">{{'NoDrillsAvailable' | translate}}</span>
    </h2>
  </soho-toolbar-flex-section>
  <!--
  todo
   - add attributes
   - add id
   - add automation ids
   - data-automation-id="lm-drill-point-data-grid"
  -->
  <ng-container *ngIf="selectedNode?.children?.length > 0 && gridOptions">
    <div soho-datagrid
        class="scrollable-flex-content"
        [gridOptions]="gridOptions"
    >
    </div>
  </ng-container>
</div>
